import { Component, OnInit } from "@angular/core";

import { from, Observable } from "rxjs";

import { DffRouteParams } from "@dffedb/router";

import { SilentLoginSandbox } from "./silent-login.sandbox";

@Component({
    templateUrl: "./silent-login.component.html"
})
export class SilentLoginComponent implements OnInit {
    public vm$: Observable<void>;

    constructor(private readonly routeParams: DffRouteParams, private readonly sandbox: SilentLoginSandbox) {}

    public async ngOnInit(): Promise<void> {
        this.vm$ = from(this.udfoerSilentLoginOgNavigerTilMitForbrug());
    }

    private async udfoerSilentLoginOgNavigerTilMitForbrug(): Promise<void> {
        const ejendomNr = parseInt(this.routeParams.get("ejendomnr"), 10);
        const aktivNr = parseInt(this.routeParams.get("aktivnr"), 10);
        const installationNr = parseInt(this.routeParams.get("installationnr"), 10);
        const cryptId = this.routeParams.get("cryptid");
        const origin = this.routeParams.get("origin");
        return await this.sandbox.udfoerSilentLoginOgNavigerTilMitForbrug(ejendomNr, aktivNr, installationNr, cryptId, origin);
    }
}
